import React from 'react';
import style from './style';

function Presenter({onChangeMinute,onChangeSec,sec,min,onSubmit,onCancel,...props}){
	return (
		<style.Wrapper {...props}>
			<style.TimerIcon />
			<style.TextInput caption='min' value={min} onChange={onChangeMinute}/>
            :
			<style.TextInput caption='sec' value={sec} onChange={onChangeSec} />
			<style.OkButton onClick={onSubmit}>OK</style.OkButton>
			<style.TextButton onClick={onCancel}>Cancel</style.TextButton>
		</style.Wrapper>
	);
}

export default Presenter;